// extracted by mini-css-extract-plugin
export var badge = "styles-module--badge--c60f6";
export var button__primary = "styles-module--button__primary--57ad3";
export var cursor = "styles-module--cursor--eb647";
export var cursorFollower = "styles-module--cursor-follower--74538";
export var headingCentered = "styles-module--heading-centered--936ce";
export var noScroll = "styles-module--no-scroll--a75f0";
export var pageTemplatePageGame = "styles-module--page-template-page-game--cc4b8";
export var section__wrapper = "styles-module--section__wrapper--73e57";
export var section__wrapperLarge = "styles-module--section__wrapper--large--1221a";